import { createContext, useContext, useState } from "react";

const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);
export const ModalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [showAddCashModal, setShowAddCashModal] = useState(false);
  const [gameUrl, setgameUrl] = useState("");
  const [useramount, setuseramount] = useState("");
  const [gamesdetails, setgamesdetails] = useState([]);
  const [gamescatdetails, setgamescatdetails] = useState([]);
  const [menuItems, setgamemenu] = useState([]);
  const [cashBalance, setCashBalance] = useState([]);
  const [OverviewGames, setOverviewGames] = useState({});
  const [showInsufficientModal, setShowInsufficientModal] = useState(false);

  return (
    <ModalContext.Provider
      value={{
        showModal,
        setShowModal,
        showAddCashModal,
        setShowAddCashModal,
        gameUrl,
        setgameUrl,
        useramount,
        setuseramount, gamesdetails, setgamesdetails, gamescatdetails, setgamescatdetails,
        menuItems, setgamemenu, cashBalance, setCashBalance,
        OverviewGames, setOverviewGames,
        showInsufficientModal,setShowInsufficientModal,  
      }}
    >
      
      {children}
    </ModalContext.Provider>
  );
};